module.exports = __webpack_public_path__ + "static/media/master_card.0bdd9a2a.svg";